var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        { attrs: { bordered: false, "dis-hover": true } },
        [
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getMainTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                              colSpan: 4,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("分账管理"),
                      ]),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "right-bar" }),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { staticClass: "main", attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                      autoHeight: true,
                      summaryLabelField: "seedFarmName",
                      summaryFields: [
                        "receiveQuantity",
                        "totalReceiveQuantity",
                        "preSaleValue",
                        "saleDiscountValue",
                        "refundAmount",
                        "compensationDetailValue",
                        "saleRealValue",
                        "combineCommission",
                        "webDev",
                        "seedlingService",
                        "guangzhouIT",
                        "promotionDept",
                        "voucherAmount",
                      ],
                      totalSummaryFieldDatas: _vm.mainTable.sumData,
                      showPage: true,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }